import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryTransportPlanningView } from "src/components/views/erp/delivery/transportPlanning/DeliveryTransportPlanningView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/delivery/transportPlanning")({
	staticData: { title: i18n.t("transport_planning"), legacyViewKey: "deliveryTransportPlanningPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryTransportPlanningView />;
}
